
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'EmptyHint',
})
export default class EmptyHint extends Vue {
    @Prop({ type: String, default: '暂无数据' }) public hint?: string;
}
